module.exports = __webpack_public_path__ + "img/thumb_07.8239362b.jpg";